import * as React from 'react';
import styled from 'styled-components';

import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { Navigation } from '@process-advisor/process-miner/modals/detail/eventDetail/navigation';
import { TabPanel } from '@process-advisor/process-miner/navigation/horizontalTabs/tabPanel';
import { EventSummaryGrid } from '@process-advisor/process-miner/modals/detail/eventDetail/eventSummaryGrid';
import { EventDetailGrid } from '@process-advisor/process-miner/modals/detail/eventDetail/eventDetailGrid';
import { CDetailTabs, DetailTabsList } from '@process-advisor/process-miner/modals/detail/eventDetail/tabs';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { Typography } from '@mui/material';

const Wrapper = styled.div`
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
`;

const Container = styled.div`
    padding: 15px;
    margin-left: -4px;
    overflow: auto;
`;

const StyledNavigation = styled.div`
    display: flex;
    justify-content: center;
`;

export const EventDetail: React.FC = () => {
    const [activeSidebarTab, setActiveSidebarTab] = React.useState<number>(
        CDetailTabs.indexOf(DetailTabsList.eventsTab)
    );
    const [description,setDescription] = React.useState<string>('');

    React.useEffect(() => {
        const listener = () => {
            setDescription(apiProvider.getDetailDescription())
        }
        listener();

        apiProvider.on(Event.openEventDetailModal, listener);

        return () => {
            apiProvider.off(Event.openEventDetailModal, listener);
        };
    }, []);

    return (
        <Wrapper>
            <Container>
                <Typography
                    variant="caption"
                    align="center"
                    sx={{ fontSize: '14px', pb: '10px', fontWeight: '600', fontFamily: 'system-ui'
}}
                    component="div">
                    {description}
                </Typography>

                <StyledNavigation>
                    <Navigation
                        onChange={setActiveSidebarTab}
                        activeTab={activeSidebarTab} />
                </StyledNavigation>
                <TabPanel
                    height='auto'
                    activeTab={activeSidebarTab}
                    tab={CDetailTabs.indexOf(DetailTabsList.eventSummaryTab)}>
                    <EventSummaryGrid />
                </TabPanel>
                <TabPanel
                    height='auto'
                    activeTab={activeSidebarTab}
                    tab={CDetailTabs.indexOf(DetailTabsList.eventsTab)}>
                    <EventDetailGrid />
                </TabPanel>
            </Container>
        </Wrapper>
    );
};
